
export function jumpTo(item){
    if(item.path == undefined) return
    if(!item.path) return alert('暂未开放。。。')
    this.$router.push({ path: item.path })
}
export function tabLeave(){
    if(new Date().getTime() - this.tabEnterTime<350 && this.timer){
        clearTimeout(this.timer)
    }
}
export function swiperEnter(name){
    this.$refs[name].swiper.stopAutoplay()
}
export function swiperLeave(name){
    this.$refs[name].swiper.startAutoplay()
}